const ANDROID_PACKAGE = "com.sh.shabani.ALBAVOXProject";
const CUSTOM_SCHEME = "albavoxproject";

function buildCustomSchemeUrl(pathname: string, search = "") {
  const normalizedPath = pathname.replace(/^\/+/, "");
  return `${CUSTOM_SCHEME}:///${normalizedPath}${search}`;
}

function buildAndroidIntentUrl(pathname: string, search = "") {
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  const hostPath = `www.albavox.com${normalizedPath}${search}`;
  return `intent://${hostPath}#Intent;scheme=https;package=${ANDROID_PACKAGE};end`;
}

/** Attempt to open the AlbaVox native app immediately (custom scheme + Android intent). */
export function tryOpenAlbaVoxApp(pathname: string, search = "") {
  const customUrl = buildCustomSchemeUrl(pathname, search);
  const ua = navigator.userAgent || "";
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);

  if (isIOS) {
    window.location.replace(customUrl);
    return;
  }

  if (isAndroid) {
    window.location.replace(buildAndroidIntentUrl(pathname, search));
    window.setTimeout(() => {
      window.location.replace(customUrl);
    }, 700);
    return;
  }

  window.location.replace(customUrl);
}

export { buildCustomSchemeUrl, buildAndroidIntentUrl };
